module.exports = __webpack_public_path__ + "static/media/net2.2db7ed69.gif";